module.exports = __webpack_public_path__ + "img/symbol_0.5be6c956.png";